import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import getConfig from '../../../../../../../../util/config';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../../constants/event-items';
import { getEventDateLabel } from '../../../../FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    onboarding_short_url: PropTypes.string,
    has_video_album: PropTypes.bool,
    is_web_gallery: PropTypes.bool,
  }),
};

const AccountMarketingMaterialWeddingFlyerTemplate = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const parsedAlbumFolderName = albumFolder.name.replace('❤', '');
  const { width } = useComponentSize(templateRef);
  const url =
    albumFolder.auto_contributor_share_url ??
    `${getConfig().app.baseUrl}/s/event-invite/${albumFolder.id}`;

  const eventDateLabel = getEventDateLabel(albumFolder);

  const includeWatermark =
    !albumFolder?.purchased_event?.features
      ?.white_label_marketing_prints_enabled &&
    !albumFolder?.purchased_event_addon_types?.includes(
      EVENT_ADDON_ITEM_TYPE.WALDOFIED,
    ) &&
    // Covers Memory Book / GV
    !(
      albumFolder?.individual_albums &&
      albumFolder?.purchased_event_addon_types?.length > 0
    );

  const hasGV = albumFolder?.purchased_event_addon_types?.includes(
    EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO,
  );

  const solicitationCopy = (() => {
    if (albumFolder?.individual_albums && hasGV) {
      return (
        <>
          Scan me to add your <br /> video message
        </>
      );
    }

    return (
      <>
        Please send us <br /> your photos{' '}
        {(albumFolder?.has_video_album || hasGV) && <>&amp; videos!</>}
      </>
    );
  })();

  return (
    <Fragment>
      <div
        style={{
          top: '49.5%',
          left: '35.1%',
          bottom: '27.3%',
          right: '35%',
        }}
        className="marketing-material-wedding-flyer-video-guestbook-qrcode"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: `${url}`,
            albumFolder,
          })}
          size={width * 0.29 ?? 232}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_MATERIAL_WEDDING_FLYER_TEMPLATE_VGB.png',
        )}
        alt=""
      />

      <div className="marketing-material-event-flyer-event-name">
        <p>{parsedAlbumFolderName}</p>
      </div>
      {eventDateLabel && (
        <div className="marketing-material-event-flyer-event-date">
          <p>{eventDateLabel}</p>
        </div>
      )}

      {includeWatermark && (
        <img
          src={getAsset('/powered-by-waldo-blue.svg')}
          alt=""
          style={{
            position: 'absolute',
            bottom: '2%',
            right: '2%',
            width: '10%',
          }}
        />
      )}

      <div className="marketing-material-event-flyer-solicitation">
        {solicitationCopy}
      </div>
    </Fragment>
  );
};

AccountMarketingMaterialWeddingFlyerTemplate.propTypes = propTypes;

export default AccountMarketingMaterialWeddingFlyerTemplate;
